export default {
  name: "RouterHolder",
  computed: {
    key: function key() {
      return this.$route.fullPath;
    }
  }
};